import { mods } from '@approvalmax/theme';
import { Field } from '@approvalmax/ui';
import { StyledMods } from '@styled-kit/mods';
import { font } from 'modules/styles';
import styled from 'styled-components';

import FileList from '../filesSection/FileList/FileList';
import { SectionContainer } from '../SectionContainer';

export const FormWrap = styled(SectionContainer)``;

export const Content = styled.div`
    display: flex;
    flex-flow: column;
`;

export const CheckboxWrap = styled.div<StyledMods<{ isEmailContactLimited: boolean }>>`
    display: flex;

    ${mods('isEmailContactLimited', true)`
        margin-bottom: 5px;
    `}
`;

export const FieldsWrap = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;

    & > :not(:last-child) {
        margin-right: 20px;
    }

    & > * {
        flex: 0.5;
        display: flex;
        flex-flow: column;

        & > :first-child {
            margin-bottom: 7px;
        }
    }
`;

export const FieldsColumnLeft = styled.div``;

export const FieldsColumnCenter = styled.div``;

export const FieldsColumnRight = styled.div`
    max-width: 32%;
`;

export const FieldsFullWidth = styled.div`
    min-width: 100%;
    margin-top: 20px;
`;

export const ContentFrom = styled.div`
    height: 28px;
    line-height: 28px;
`;

export const ContentReplyTo = styled.div`
    height: 28px;
    line-height: 28px;
`;

export const FilesWrap = styled(Field)`
    margin-top: 10px;
`;

export const NoteWrap = styled.div`
    display: flex;
    align-items: center;
    margin-top: 5px;
`;

export const FilesNote = styled.div`
    ${font(12, '#7f7d7d', 'standard')}
    margin-left: 5px;
`;

export const FilesList = styled(FileList)`
    margin-top: 10px;
`;
